module.exports = __webpack_public_path__ + "static/media/checkin-mobile2.6117489f.jpg";